"use strict";

var threeLetterSequenceStringToAminoAcidMap = require("./threeLetterSequenceStringToAminoAcidMap");
var proteinAlphabet = require("./proteinAlphabet");
var degenerateDnaToAminoAcidMap = require("./degenerateDnaToAminoAcidMap");

//tnrtodo: expand the threeLetterSequenceStringToAminoAcidMap mappings to include RNA characters.
//currently stop bps aren't all mapped!
module.exports = function getAminoAcidFromSequenceTriplet(sequenceString) {
  sequenceString = sequenceString.toLowerCase();
  if (sequenceString.length !== 3) {
    throw new Error("must pass a string of length 3");
  }
  var aa = threeLetterSequenceStringToAminoAcidMap[sequenceString];
  if (aa) {
    return aa;
  }
  var letter = degenerateDnaToAminoAcidMap[sequenceString.replace("x", "n") //replace x's with n's as those are equivalent dna chars
  ] || "x";

  return proteinAlphabet[letter.toUpperCase()];
};